import React from "react"

export default function ButtonEdit({ onClick }) {
  return (
    <button type="button" className="btn btn-tool" onClick={onClick} style={{ opacity: "0.4" }}>
      <i className="far fa-edit" />
    </button>
  )
}
